<template>
  <div id="app">
    <divHeader />
    <divLogin v-if="$store.state.login" />
    <router-view />
    <divFooter />
  </div>
</template>

<script>
import divHeader from '@/components/headers.vue'
import divFooter from '@/components/footers.vue'
import divLogin from '@/components/login.vue'

export default {
  name: 'App',
  components: {
    divHeader,
    divFooter,
    divLogin
  }
}
</script>

<style>
/* 这里可以放一些全局样式 */
</style>
